import React, { useMemo } from 'react';
import { __ } from '@wordpress/i18n';
import { head, isEmpty } from 'ramda';

// store
import { useStoreValue } from '../../store';

// components
import { Link } from 'react-router-dom';
import DocumentsRequiredTable from './components/DocumentsRequiredTable';


const DocumentsBeneficiary = () => {
    const chosenCompanyId = useStoreValue('chosenCompanyId');
    const companies = useStoreValue('companies');
    const existingCompany = useMemo(() => head(companies.filter(o => o.id === chosenCompanyId)), [companies, chosenCompanyId]);

    return (
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Gestione documenti', 'htr')}</h1>
                {existingCompany ? <span className="companyName">{existingCompany.companyName}</span> : null}
            </div>

            <div className="appPage__spacer"></div>
            {isEmpty(chosenCompanyId) || chosenCompanyId === 0
                ? <>
                    <div className="appPageSection__message warning">
                        <i className="pi pi-exclamation-triangle"></i>
                        <span className="summary">{__('Attenzione', 'htr')}</span>
                        <span>
                            {__('Per caricare i file devi Registare un Azienda clicca', 'htr')}
                            <Link to={`/agguingi-azienda`} style={{ marginLeft: '0.5ch' }}>{__('qua', 'htr')}</Link>
                        </span>
                    </div>
                    <div className="appPage__spacer"></div>
                </> : null}

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <h2>
                    {__('Documenti Richiesti', 'htr')}
                </h2>
                <p>{__('Gentile fornitore, il presente questionario è da compilare nella sua interezza. In caso di mancanza del documento richiesto si chiede di inserire una dichiarazione di non applicabilità con le relative motivazioni o eventuali dettagli utili a chiarire la propria posizione. Grazie!', 'htr')}</p>
                {/* Al ricaricamento diretto della pagina l'azienda arriva dopo lo store: si aspetta, senza esplodere su company.id. */}
                {existingCompany ? <DocumentsRequiredTable company={existingCompany}/> : null}
            </div>
        </div>
    )
}

export default DocumentsBeneficiary;